import { Outlet, Navigate, useLocation, useRevalidator } from 'react-router-dom';

import { AccessProvider } from '../access';
import { OnboardingGate } from '../modules/onboarding';
import { useSignedOutOnRestore } from '../utilities/customHooks/useSignedOutOnRestore';

export default function AuthenticatedRoute() {
    useSignedOutOnRestore();
    const { revalidate } = useRevalidator();
    const isLoggedIn = localStorage.getItem('userId');
    const location = useLocation();
    if (!isLoggedIn) {
        return (
            <Navigate
                to="/Login"
                replace
                state={{
                    from: location.pathname + location.search,
                }}
            />
        );
    }
    return (
        <AccessProvider onAccessChanged={revalidate}>
            <OnboardingGate>
                <Outlet />
            </OnboardingGate>
        </AccessProvider>
    );
}
